import React, { useEffect } from "react";
import DataPembelianSupplier from "../../componen/supplierPenyedia/DataPembelianSupplier";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMeAdmin } from "../../fitur/AuthSlice";
import { Layout } from "../../layout/Layout";

export const DataPembelianSupplierPages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.authAdmin);

  useEffect(() => { dispatch(getMeAdmin()); }, [dispatch]);
  useEffect(() => { if (isError) navigate("/"); }, [isError, navigate]);

  return (
    <Layout>
      <DataPembelianSupplier />
    </Layout>
  );
};
